module.exports = __webpack_public_path__ + "img/pulp_processing_1200x800.0d038b5f.svg";